export var VERSION = '2.23.6';
//# sourceMappingURL=version.js.map